import React from 'react';
import { Container, Typography, Paper, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ReceptionistRegistrationPage = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('receptionist:registration.title')}
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Alert severity="info">
          {t('receptionist:registration.comingSoon')}
        </Alert>
      </Paper>
    </Container>
  );
};

export default ReceptionistRegistrationPage;

